import { Dispute } from 'api/escrow/types';

type Props = { dispute: Dispute };

export default function DecisionSection({ dispute }: Props) {
  if (dispute.status === 'deemed_loss_resolved') {
    return (
      <div className="bg-[#E94169]/10 rounded-lg p-4 md:p-6">
        <h3 className="text-lg font-bold text-[#E94169] mb-2">Trade Terminated — Deemed Loss</h3>
        <p className="text-sm text-brand-black">
          The funding deadline has passed. The non-funding party&apos;s escrow deposit has been forfeited. This dispute
          is now closed.
        </p>
      </div>
    );
  }

  return (
    <div className="bg-brand-purple-card rounded-lg p-4 md:p-6">
      <h3 className="text-lg font-bold text-brand-black mb-4">Arbitration Decision</h3>

      {dispute.decisionOutcome ? (
        <div className="flex flex-col gap-3">
          <div>
            <p className="text-xs text-gray-500">Outcome</p>
            <p className="text-sm font-semibold text-brand-black capitalize">{dispute.decisionOutcome}</p>
          </div>

          {dispute.faultParty && (
            <div>
              <p className="text-xs text-gray-500">Fault Party</p>
              <p className="text-sm font-semibold text-brand-black capitalize">{dispute.faultParty}</p>
            </div>
          )}

          {(dispute.buyerFaultPercent != null || dispute.sellerFaultPercent != null) && (
            <div className="grid grid-cols-2 gap-3">
              <div>
                <p className="text-xs text-gray-500">Buyer Fault</p>
                <p className="text-sm font-semibold text-brand-black">{dispute.buyerFaultPercent ?? 0}%</p>
              </div>
              <div>
                <p className="text-xs text-gray-500">Seller Fault</p>
                <p className="text-sm font-semibold text-brand-black">{dispute.sellerFaultPercent ?? 0}%</p>
              </div>
            </div>
          )}

          {dispute.decisionSummary && (
            <div>
              <p className="text-xs text-gray-500">Summary</p>
              <p className="text-sm text-brand-black mt-1 whitespace-pre-wrap">{dispute.decisionSummary}</p>
            </div>
          )}
        </div>
      ) : (
        <p className="text-sm text-gray-500">
          {dispute.status === 'arbitration_decision_issued'
            ? 'Decision has been issued. Settlement is being processed.'
            : 'This case has been closed.'}
        </p>
      )}
    </div>
  );
}
